import Panel from './PanelCustom';

export default Panel;
